module.exports = __webpack_public_path__ + "files/3e210fedb36750f01af0819af7c46d36.png";